export default function initChangeSiteModal() {

  var c = {
    init: function(){
      $(".change-site-modal").click(c.showModal);
      $(".change-website").click(c.changeSite);
      $("#searchInput").keyup(c.filterList);
    },
    filterList: function(){
      var input, filter, table, tr, td, i, txtValue, list, li;
      input = document.getElementById("searchInput");
      filter = input.value.toUpperCase();
      list = document.getElementById("filterList");
      li = list.getElementsByTagName("li");

      for (i = 0; i < li.length; i++) {
        var match = li[i].getAttribute("data-names");
        if (match) {
          if (match.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
          } else {
            li[i].style.display = "none";
          }
        }
      }
    },
    changeSite: function(e){
      var baseUrl = window.location.origin;
      var newSiteToken = $(this).data("website")
      var currentSite = $(this).data("current-site");

      var redirectUrl = baseUrl + "/live/"+newSiteToken;
      if( currentSite.length && window.location.href.includes(currentSite) ){
        var path = window.location.pathname.split("/")
        if( typeof path[1] !== "undefined" ){
          redirectUrl = baseUrl + "/" + path[1]
        }
        if( typeof path[2] !== "undefined" ){
          redirectUrl += "/" + path[2]
        }
        redirectUrl = redirectUrl.replace(currentSite, newSiteToken);
      }
      $('#change-site-modal').modal('hide');
      $(".loading-overlay").show();
      window.location.href = redirectUrl;
    },
    showModal: function(e){
      event.preventDefault();
      $('body').removeClass('navbar-nav-show');
      $('#change-site-modal').modal()
      $("#searchInput").focus();
    }

  };

  $(document).ready(c.init);


}
